// extracted by mini-css-extract-plugin
module.exports = {"footer":"CbFooter_footer__56ESp","footerContent":"CbFooter_footerContent__mtsWk"};